/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as SubscribeRouteImport } from './routes/subscribe'
import { Route as SigninRouteImport } from './routes/signin'
import { Route as SettingsRouteImport } from './routes/settings'
import { Route as ResetPasswordRouteImport } from './routes/reset-password'
import { Route as RegisterRouteImport } from './routes/register'
import { Route as OrganisationRouteImport } from './routes/organisation'
import { Route as LegalRouteImport } from './routes/legal'
import { Route as ForgotPasswordRouteImport } from './routes/forgot-password'
import { Route as CheckoutRouteImport } from './routes/checkout'
import { Route as AuthRouteImport } from './routes/auth'
import { Route as AppRouteImport } from './routes/app'
import { Route as IndexRouteImport } from './routes/index'
import { Route as SettingsIndexRouteImport } from './routes/settings/index'
import { Route as OrganisationIndexRouteImport } from './routes/organisation/index'
import { Route as CheckoutIndexRouteImport } from './routes/checkout/index'
import { Route as AppIndexRouteImport } from './routes/app/index'
import { Route as SettingsSupportRouteImport } from './routes/settings/support'
import { Route as SettingsSecurityRouteImport } from './routes/settings/security'
import { Route as SettingsProfileRouteImport } from './routes/settings/profile'
import { Route as SettingsPreferencesRouteImport } from './routes/settings/preferences'
import { Route as SettingsInvitationsRouteImport } from './routes/settings/invitations'
import { Route as OrganisationPermissionsRouteImport } from './routes/organisation/permissions'
import { Route as OrganisationNewRouteImport } from './routes/organisation/new'
import { Route as OrganisationMembersRouteImport } from './routes/organisation/members'
import { Route as OrganisationGeneralRouteImport } from './routes/organisation/general'
import { Route as OrganisationClientTransfersRouteImport } from './routes/organisation/client-transfers'
import { Route as OrganisationBillingRouteImport } from './routes/organisation/billing'
import { Route as ConsentInfoRouteImport } from './routes/consent.info'
import { Route as ConsentTokenRouteImport } from './routes/consent.$token'
import { Route as CheckoutSuccessRouteImport } from './routes/checkout/success'
import { Route as AppTemplatesRouteImport } from './routes/app/templates'
import { Route as AppSettingsRouteImport } from './routes/app/settings'
import { Route as AppFaqRouteImport } from './routes/app/faq'
import { Route as SettingsSupportIndexRouteImport } from './routes/settings/support/index'
import { Route as AppClientsIndexRouteImport } from './routes/app/clients/index'
import { Route as SettingsSupportNewRouteImport } from './routes/settings/support/new'
import { Route as SettingsSupportThreadIdRouteImport } from './routes/settings/support/$threadId'
import { Route as MobileRecordTokenRouteImport } from './routes/mobile.record.$token'
import { Route as AppTemplateNewRouteImport } from './routes/app/template/new'
import { Route as AppTemplateTemplateIdRouteImport } from './routes/app/template/$templateId'
import { Route as AppClientsClientIdRouteImport } from './routes/app/clients/$clientId'
import { Route as AppClientsClientIdIndexRouteImport } from './routes/app/clients/$clientId/index'
import { Route as AppClientsClientIdSessionEventIdRouteImport } from './routes/app/clients/$clientId/session/$eventId'
import { Route as AppClientsClientIdDocumentDocumentIdRouteImport } from './routes/app/clients/$clientId/document/$documentId'

const SubscribeRoute = SubscribeRouteImport.update({
  id: '/subscribe',
  path: '/subscribe',
  getParentRoute: () => rootRouteImport,
} as any)
const SigninRoute = SigninRouteImport.update({
  id: '/signin',
  path: '/signin',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsRoute = SettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => rootRouteImport,
} as any)
const ResetPasswordRoute = ResetPasswordRouteImport.update({
  id: '/reset-password',
  path: '/reset-password',
  getParentRoute: () => rootRouteImport,
} as any)
const RegisterRoute = RegisterRouteImport.update({
  id: '/register',
  path: '/register',
  getParentRoute: () => rootRouteImport,
} as any)
const OrganisationRoute = OrganisationRouteImport.update({
  id: '/organisation',
  path: '/organisation',
  getParentRoute: () => rootRouteImport,
} as any)
const LegalRoute = LegalRouteImport.update({
  id: '/legal',
  path: '/legal',
  getParentRoute: () => rootRouteImport,
} as any)
const ForgotPasswordRoute = ForgotPasswordRouteImport.update({
  id: '/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => rootRouteImport,
} as any)
const CheckoutRoute = CheckoutRouteImport.update({
  id: '/checkout',
  path: '/checkout',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthRoute = AuthRouteImport.update({
  id: '/auth',
  path: '/auth',
  getParentRoute: () => rootRouteImport,
} as any)
const AppRoute = AppRouteImport.update({
  id: '/app',
  path: '/app',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsIndexRoute = SettingsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => SettingsRoute,
} as any)
const OrganisationIndexRoute = OrganisationIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => OrganisationRoute,
} as any)
const CheckoutIndexRoute = CheckoutIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => CheckoutRoute,
} as any)
const AppIndexRoute = AppIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppRoute,
} as any)
const SettingsSupportRoute = SettingsSupportRouteImport.update({
  id: '/support',
  path: '/support',
  getParentRoute: () => SettingsRoute,
} as any)
const SettingsSecurityRoute = SettingsSecurityRouteImport.update({
  id: '/security',
  path: '/security',
  getParentRoute: () => SettingsRoute,
} as any)
const SettingsProfileRoute = SettingsProfileRouteImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => SettingsRoute,
} as any)
const SettingsPreferencesRoute = SettingsPreferencesRouteImport.update({
  id: '/preferences',
  path: '/preferences',
  getParentRoute: () => SettingsRoute,
} as any)
const SettingsInvitationsRoute = SettingsInvitationsRouteImport.update({
  id: '/invitations',
  path: '/invitations',
  getParentRoute: () => SettingsRoute,
} as any)
const OrganisationPermissionsRoute = OrganisationPermissionsRouteImport.update({
  id: '/permissions',
  path: '/permissions',
  getParentRoute: () => OrganisationRoute,
} as any)
const OrganisationNewRoute = OrganisationNewRouteImport.update({
  id: '/new',
  path: '/new',
  getParentRoute: () => OrganisationRoute,
} as any)
const OrganisationMembersRoute = OrganisationMembersRouteImport.update({
  id: '/members',
  path: '/members',
  getParentRoute: () => OrganisationRoute,
} as any)
const OrganisationGeneralRoute = OrganisationGeneralRouteImport.update({
  id: '/general',
  path: '/general',
  getParentRoute: () => OrganisationRoute,
} as any)
const OrganisationClientTransfersRoute =
  OrganisationClientTransfersRouteImport.update({
    id: '/client-transfers',
    path: '/client-transfers',
    getParentRoute: () => OrganisationRoute,
  } as any)
const OrganisationBillingRoute = OrganisationBillingRouteImport.update({
  id: '/billing',
  path: '/billing',
  getParentRoute: () => OrganisationRoute,
} as any)
const ConsentInfoRoute = ConsentInfoRouteImport.update({
  id: '/consent/info',
  path: '/consent/info',
  getParentRoute: () => rootRouteImport,
} as any)
const ConsentTokenRoute = ConsentTokenRouteImport.update({
  id: '/consent/$token',
  path: '/consent/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const CheckoutSuccessRoute = CheckoutSuccessRouteImport.update({
  id: '/success',
  path: '/success',
  getParentRoute: () => CheckoutRoute,
} as any)
const AppTemplatesRoute = AppTemplatesRouteImport.update({
  id: '/templates',
  path: '/templates',
  getParentRoute: () => AppRoute,
} as any)
const AppSettingsRoute = AppSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AppRoute,
} as any)
const AppFaqRoute = AppFaqRouteImport.update({
  id: '/faq',
  path: '/faq',
  getParentRoute: () => AppRoute,
} as any)
const SettingsSupportIndexRoute = SettingsSupportIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => SettingsSupportRoute,
} as any)
const AppClientsIndexRoute = AppClientsIndexRouteImport.update({
  id: '/clients/',
  path: '/clients/',
  getParentRoute: () => AppRoute,
} as any)
const SettingsSupportNewRoute = SettingsSupportNewRouteImport.update({
  id: '/new',
  path: '/new',
  getParentRoute: () => SettingsSupportRoute,
} as any)
const SettingsSupportThreadIdRoute = SettingsSupportThreadIdRouteImport.update({
  id: '/$threadId',
  path: '/$threadId',
  getParentRoute: () => SettingsSupportRoute,
} as any)
const MobileRecordTokenRoute = MobileRecordTokenRouteImport.update({
  id: '/mobile/record/$token',
  path: '/mobile/record/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const AppTemplateNewRoute = AppTemplateNewRouteImport.update({
  id: '/template/new',
  path: '/template/new',
  getParentRoute: () => AppRoute,
} as any)
const AppTemplateTemplateIdRoute = AppTemplateTemplateIdRouteImport.update({
  id: '/template/$templateId',
  path: '/template/$templateId',
  getParentRoute: () => AppRoute,
} as any)
const AppClientsClientIdRoute = AppClientsClientIdRouteImport.update({
  id: '/clients/$clientId',
  path: '/clients/$clientId',
  getParentRoute: () => AppRoute,
} as any)
const AppClientsClientIdIndexRoute = AppClientsClientIdIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppClientsClientIdRoute,
} as any)
const AppClientsClientIdSessionEventIdRoute =
  AppClientsClientIdSessionEventIdRouteImport.update({
    id: '/session/$eventId',
    path: '/session/$eventId',
    getParentRoute: () => AppClientsClientIdRoute,
  } as any)
const AppClientsClientIdDocumentDocumentIdRoute =
  AppClientsClientIdDocumentDocumentIdRouteImport.update({
    id: '/document/$documentId',
    path: '/document/$documentId',
    getParentRoute: () => AppClientsClientIdRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/app': typeof AppRouteWithChildren
  '/auth': typeof AuthRoute
  '/checkout': typeof CheckoutRouteWithChildren
  '/forgot-password': typeof ForgotPasswordRoute
  '/legal': typeof LegalRoute
  '/organisation': typeof OrganisationRouteWithChildren
  '/register': typeof RegisterRoute
  '/reset-password': typeof ResetPasswordRoute
  '/settings': typeof SettingsRouteWithChildren
  '/signin': typeof SigninRoute
  '/subscribe': typeof SubscribeRoute
  '/app/faq': typeof AppFaqRoute
  '/app/settings': typeof AppSettingsRoute
  '/app/templates': typeof AppTemplatesRoute
  '/checkout/success': typeof CheckoutSuccessRoute
  '/consent/$token': typeof ConsentTokenRoute
  '/consent/info': typeof ConsentInfoRoute
  '/organisation/billing': typeof OrganisationBillingRoute
  '/organisation/client-transfers': typeof OrganisationClientTransfersRoute
  '/organisation/general': typeof OrganisationGeneralRoute
  '/organisation/members': typeof OrganisationMembersRoute
  '/organisation/new': typeof OrganisationNewRoute
  '/organisation/permissions': typeof OrganisationPermissionsRoute
  '/settings/invitations': typeof SettingsInvitationsRoute
  '/settings/preferences': typeof SettingsPreferencesRoute
  '/settings/profile': typeof SettingsProfileRoute
  '/settings/security': typeof SettingsSecurityRoute
  '/settings/support': typeof SettingsSupportRouteWithChildren
  '/app/': typeof AppIndexRoute
  '/checkout/': typeof CheckoutIndexRoute
  '/organisation/': typeof OrganisationIndexRoute
  '/settings/': typeof SettingsIndexRoute
  '/app/clients/$clientId': typeof AppClientsClientIdRouteWithChildren
  '/app/template/$templateId': typeof AppTemplateTemplateIdRoute
  '/app/template/new': typeof AppTemplateNewRoute
  '/mobile/record/$token': typeof MobileRecordTokenRoute
  '/settings/support/$threadId': typeof SettingsSupportThreadIdRoute
  '/settings/support/new': typeof SettingsSupportNewRoute
  '/app/clients/': typeof AppClientsIndexRoute
  '/settings/support/': typeof SettingsSupportIndexRoute
  '/app/clients/$clientId/': typeof AppClientsClientIdIndexRoute
  '/app/clients/$clientId/document/$documentId': typeof AppClientsClientIdDocumentDocumentIdRoute
  '/app/clients/$clientId/session/$eventId': typeof AppClientsClientIdSessionEventIdRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/auth': typeof AuthRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/legal': typeof LegalRoute
  '/register': typeof RegisterRoute
  '/reset-password': typeof ResetPasswordRoute
  '/signin': typeof SigninRoute
  '/subscribe': typeof SubscribeRoute
  '/app/faq': typeof AppFaqRoute
  '/app/settings': typeof AppSettingsRoute
  '/app/templates': typeof AppTemplatesRoute
  '/checkout/success': typeof CheckoutSuccessRoute
  '/consent/$token': typeof ConsentTokenRoute
  '/consent/info': typeof ConsentInfoRoute
  '/organisation/billing': typeof OrganisationBillingRoute
  '/organisation/client-transfers': typeof OrganisationClientTransfersRoute
  '/organisation/general': typeof OrganisationGeneralRoute
  '/organisation/members': typeof OrganisationMembersRoute
  '/organisation/new': typeof OrganisationNewRoute
  '/organisation/permissions': typeof OrganisationPermissionsRoute
  '/settings/invitations': typeof SettingsInvitationsRoute
  '/settings/preferences': typeof SettingsPreferencesRoute
  '/settings/profile': typeof SettingsProfileRoute
  '/settings/security': typeof SettingsSecurityRoute
  '/app': typeof AppIndexRoute
  '/checkout': typeof CheckoutIndexRoute
  '/organisation': typeof OrganisationIndexRoute
  '/settings': typeof SettingsIndexRoute
  '/app/template/$templateId': typeof AppTemplateTemplateIdRoute
  '/app/template/new': typeof AppTemplateNewRoute
  '/mobile/record/$token': typeof MobileRecordTokenRoute
  '/settings/support/$threadId': typeof SettingsSupportThreadIdRoute
  '/settings/support/new': typeof SettingsSupportNewRoute
  '/app/clients': typeof AppClientsIndexRoute
  '/settings/support': typeof SettingsSupportIndexRoute
  '/app/clients/$clientId': typeof AppClientsClientIdIndexRoute
  '/app/clients/$clientId/document/$documentId': typeof AppClientsClientIdDocumentDocumentIdRoute
  '/app/clients/$clientId/session/$eventId': typeof AppClientsClientIdSessionEventIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/app': typeof AppRouteWithChildren
  '/auth': typeof AuthRoute
  '/checkout': typeof CheckoutRouteWithChildren
  '/forgot-password': typeof ForgotPasswordRoute
  '/legal': typeof LegalRoute
  '/organisation': typeof OrganisationRouteWithChildren
  '/register': typeof RegisterRoute
  '/reset-password': typeof ResetPasswordRoute
  '/settings': typeof SettingsRouteWithChildren
  '/signin': typeof SigninRoute
  '/subscribe': typeof SubscribeRoute
  '/app/faq': typeof AppFaqRoute
  '/app/settings': typeof AppSettingsRoute
  '/app/templates': typeof AppTemplatesRoute
  '/checkout/success': typeof CheckoutSuccessRoute
  '/consent/$token': typeof ConsentTokenRoute
  '/consent/info': typeof ConsentInfoRoute
  '/organisation/billing': typeof OrganisationBillingRoute
  '/organisation/client-transfers': typeof OrganisationClientTransfersRoute
  '/organisation/general': typeof OrganisationGeneralRoute
  '/organisation/members': typeof OrganisationMembersRoute
  '/organisation/new': typeof OrganisationNewRoute
  '/organisation/permissions': typeof OrganisationPermissionsRoute
  '/settings/invitations': typeof SettingsInvitationsRoute
  '/settings/preferences': typeof SettingsPreferencesRoute
  '/settings/profile': typeof SettingsProfileRoute
  '/settings/security': typeof SettingsSecurityRoute
  '/settings/support': typeof SettingsSupportRouteWithChildren
  '/app/': typeof AppIndexRoute
  '/checkout/': typeof CheckoutIndexRoute
  '/organisation/': typeof OrganisationIndexRoute
  '/settings/': typeof SettingsIndexRoute
  '/app/clients/$clientId': typeof AppClientsClientIdRouteWithChildren
  '/app/template/$templateId': typeof AppTemplateTemplateIdRoute
  '/app/template/new': typeof AppTemplateNewRoute
  '/mobile/record/$token': typeof MobileRecordTokenRoute
  '/settings/support/$threadId': typeof SettingsSupportThreadIdRoute
  '/settings/support/new': typeof SettingsSupportNewRoute
  '/app/clients/': typeof AppClientsIndexRoute
  '/settings/support/': typeof SettingsSupportIndexRoute
  '/app/clients/$clientId/': typeof AppClientsClientIdIndexRoute
  '/app/clients/$clientId/document/$documentId': typeof AppClientsClientIdDocumentDocumentIdRoute
  '/app/clients/$clientId/session/$eventId': typeof AppClientsClientIdSessionEventIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/app'
    | '/auth'
    | '/checkout'
    | '/forgot-password'
    | '/legal'
    | '/organisation'
    | '/register'
    | '/reset-password'
    | '/settings'
    | '/signin'
    | '/subscribe'
    | '/app/faq'
    | '/app/settings'
    | '/app/templates'
    | '/checkout/success'
    | '/consent/$token'
    | '/consent/info'
    | '/organisation/billing'
    | '/organisation/client-transfers'
    | '/organisation/general'
    | '/organisation/members'
    | '/organisation/new'
    | '/organisation/permissions'
    | '/settings/invitations'
    | '/settings/preferences'
    | '/settings/profile'
    | '/settings/security'
    | '/settings/support'
    | '/app/'
    | '/checkout/'
    | '/organisation/'
    | '/settings/'
    | '/app/clients/$clientId'
    | '/app/template/$templateId'
    | '/app/template/new'
    | '/mobile/record/$token'
    | '/settings/support/$threadId'
    | '/settings/support/new'
    | '/app/clients/'
    | '/settings/support/'
    | '/app/clients/$clientId/'
    | '/app/clients/$clientId/document/$documentId'
    | '/app/clients/$clientId/session/$eventId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/auth'
    | '/forgot-password'
    | '/legal'
    | '/register'
    | '/reset-password'
    | '/signin'
    | '/subscribe'
    | '/app/faq'
    | '/app/settings'
    | '/app/templates'
    | '/checkout/success'
    | '/consent/$token'
    | '/consent/info'
    | '/organisation/billing'
    | '/organisation/client-transfers'
    | '/organisation/general'
    | '/organisation/members'
    | '/organisation/new'
    | '/organisation/permissions'
    | '/settings/invitations'
    | '/settings/preferences'
    | '/settings/profile'
    | '/settings/security'
    | '/app'
    | '/checkout'
    | '/organisation'
    | '/settings'
    | '/app/template/$templateId'
    | '/app/template/new'
    | '/mobile/record/$token'
    | '/settings/support/$threadId'
    | '/settings/support/new'
    | '/app/clients'
    | '/settings/support'
    | '/app/clients/$clientId'
    | '/app/clients/$clientId/document/$documentId'
    | '/app/clients/$clientId/session/$eventId'
  id:
    | '__root__'
    | '/'
    | '/app'
    | '/auth'
    | '/checkout'
    | '/forgot-password'
    | '/legal'
    | '/organisation'
    | '/register'
    | '/reset-password'
    | '/settings'
    | '/signin'
    | '/subscribe'
    | '/app/faq'
    | '/app/settings'
    | '/app/templates'
    | '/checkout/success'
    | '/consent/$token'
    | '/consent/info'
    | '/organisation/billing'
    | '/organisation/client-transfers'
    | '/organisation/general'
    | '/organisation/members'
    | '/organisation/new'
    | '/organisation/permissions'
    | '/settings/invitations'
    | '/settings/preferences'
    | '/settings/profile'
    | '/settings/security'
    | '/settings/support'
    | '/app/'
    | '/checkout/'
    | '/organisation/'
    | '/settings/'
    | '/app/clients/$clientId'
    | '/app/template/$templateId'
    | '/app/template/new'
    | '/mobile/record/$token'
    | '/settings/support/$threadId'
    | '/settings/support/new'
    | '/app/clients/'
    | '/settings/support/'
    | '/app/clients/$clientId/'
    | '/app/clients/$clientId/document/$documentId'
    | '/app/clients/$clientId/session/$eventId'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AppRoute: typeof AppRouteWithChildren
  AuthRoute: typeof AuthRoute
  CheckoutRoute: typeof CheckoutRouteWithChildren
  ForgotPasswordRoute: typeof ForgotPasswordRoute
  LegalRoute: typeof LegalRoute
  OrganisationRoute: typeof OrganisationRouteWithChildren
  RegisterRoute: typeof RegisterRoute
  ResetPasswordRoute: typeof ResetPasswordRoute
  SettingsRoute: typeof SettingsRouteWithChildren
  SigninRoute: typeof SigninRoute
  SubscribeRoute: typeof SubscribeRoute
  ConsentTokenRoute: typeof ConsentTokenRoute
  ConsentInfoRoute: typeof ConsentInfoRoute
  MobileRecordTokenRoute: typeof MobileRecordTokenRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/subscribe': {
      id: '/subscribe'
      path: '/subscribe'
      fullPath: '/subscribe'
      preLoaderRoute: typeof SubscribeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/signin': {
      id: '/signin'
      path: '/signin'
      fullPath: '/signin'
      preLoaderRoute: typeof SigninRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings': {
      id: '/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof SettingsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reset-password': {
      id: '/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof ResetPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/register': {
      id: '/register'
      path: '/register'
      fullPath: '/register'
      preLoaderRoute: typeof RegisterRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/organisation': {
      id: '/organisation'
      path: '/organisation'
      fullPath: '/organisation'
      preLoaderRoute: typeof OrganisationRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/legal': {
      id: '/legal'
      path: '/legal'
      fullPath: '/legal'
      preLoaderRoute: typeof LegalRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/forgot-password': {
      id: '/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof ForgotPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/checkout': {
      id: '/checkout'
      path: '/checkout'
      fullPath: '/checkout'
      preLoaderRoute: typeof CheckoutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth': {
      id: '/auth'
      path: '/auth'
      fullPath: '/auth'
      preLoaderRoute: typeof AuthRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/app': {
      id: '/app'
      path: '/app'
      fullPath: '/app'
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/': {
      id: '/settings/'
      path: '/'
      fullPath: '/settings/'
      preLoaderRoute: typeof SettingsIndexRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/organisation/': {
      id: '/organisation/'
      path: '/'
      fullPath: '/organisation/'
      preLoaderRoute: typeof OrganisationIndexRouteImport
      parentRoute: typeof OrganisationRoute
    }
    '/checkout/': {
      id: '/checkout/'
      path: '/'
      fullPath: '/checkout/'
      preLoaderRoute: typeof CheckoutIndexRouteImport
      parentRoute: typeof CheckoutRoute
    }
    '/app/': {
      id: '/app/'
      path: '/'
      fullPath: '/app/'
      preLoaderRoute: typeof AppIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/settings/support': {
      id: '/settings/support'
      path: '/support'
      fullPath: '/settings/support'
      preLoaderRoute: typeof SettingsSupportRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/settings/security': {
      id: '/settings/security'
      path: '/security'
      fullPath: '/settings/security'
      preLoaderRoute: typeof SettingsSecurityRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/settings/profile': {
      id: '/settings/profile'
      path: '/profile'
      fullPath: '/settings/profile'
      preLoaderRoute: typeof SettingsProfileRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/settings/preferences': {
      id: '/settings/preferences'
      path: '/preferences'
      fullPath: '/settings/preferences'
      preLoaderRoute: typeof SettingsPreferencesRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/settings/invitations': {
      id: '/settings/invitations'
      path: '/invitations'
      fullPath: '/settings/invitations'
      preLoaderRoute: typeof SettingsInvitationsRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/organisation/permissions': {
      id: '/organisation/permissions'
      path: '/permissions'
      fullPath: '/organisation/permissions'
      preLoaderRoute: typeof OrganisationPermissionsRouteImport
      parentRoute: typeof OrganisationRoute
    }
    '/organisation/new': {
      id: '/organisation/new'
      path: '/new'
      fullPath: '/organisation/new'
      preLoaderRoute: typeof OrganisationNewRouteImport
      parentRoute: typeof OrganisationRoute
    }
    '/organisation/members': {
      id: '/organisation/members'
      path: '/members'
      fullPath: '/organisation/members'
      preLoaderRoute: typeof OrganisationMembersRouteImport
      parentRoute: typeof OrganisationRoute
    }
    '/organisation/general': {
      id: '/organisation/general'
      path: '/general'
      fullPath: '/organisation/general'
      preLoaderRoute: typeof OrganisationGeneralRouteImport
      parentRoute: typeof OrganisationRoute
    }
    '/organisation/client-transfers': {
      id: '/organisation/client-transfers'
      path: '/client-transfers'
      fullPath: '/organisation/client-transfers'
      preLoaderRoute: typeof OrganisationClientTransfersRouteImport
      parentRoute: typeof OrganisationRoute
    }
    '/organisation/billing': {
      id: '/organisation/billing'
      path: '/billing'
      fullPath: '/organisation/billing'
      preLoaderRoute: typeof OrganisationBillingRouteImport
      parentRoute: typeof OrganisationRoute
    }
    '/consent/info': {
      id: '/consent/info'
      path: '/consent/info'
      fullPath: '/consent/info'
      preLoaderRoute: typeof ConsentInfoRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/consent/$token': {
      id: '/consent/$token'
      path: '/consent/$token'
      fullPath: '/consent/$token'
      preLoaderRoute: typeof ConsentTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/checkout/success': {
      id: '/checkout/success'
      path: '/success'
      fullPath: '/checkout/success'
      preLoaderRoute: typeof CheckoutSuccessRouteImport
      parentRoute: typeof CheckoutRoute
    }
    '/app/templates': {
      id: '/app/templates'
      path: '/templates'
      fullPath: '/app/templates'
      preLoaderRoute: typeof AppTemplatesRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/settings': {
      id: '/app/settings'
      path: '/settings'
      fullPath: '/app/settings'
      preLoaderRoute: typeof AppSettingsRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/faq': {
      id: '/app/faq'
      path: '/faq'
      fullPath: '/app/faq'
      preLoaderRoute: typeof AppFaqRouteImport
      parentRoute: typeof AppRoute
    }
    '/settings/support/': {
      id: '/settings/support/'
      path: '/'
      fullPath: '/settings/support/'
      preLoaderRoute: typeof SettingsSupportIndexRouteImport
      parentRoute: typeof SettingsSupportRoute
    }
    '/app/clients/': {
      id: '/app/clients/'
      path: '/clients'
      fullPath: '/app/clients/'
      preLoaderRoute: typeof AppClientsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/settings/support/new': {
      id: '/settings/support/new'
      path: '/new'
      fullPath: '/settings/support/new'
      preLoaderRoute: typeof SettingsSupportNewRouteImport
      parentRoute: typeof SettingsSupportRoute
    }
    '/settings/support/$threadId': {
      id: '/settings/support/$threadId'
      path: '/$threadId'
      fullPath: '/settings/support/$threadId'
      preLoaderRoute: typeof SettingsSupportThreadIdRouteImport
      parentRoute: typeof SettingsSupportRoute
    }
    '/mobile/record/$token': {
      id: '/mobile/record/$token'
      path: '/mobile/record/$token'
      fullPath: '/mobile/record/$token'
      preLoaderRoute: typeof MobileRecordTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/app/template/new': {
      id: '/app/template/new'
      path: '/template/new'
      fullPath: '/app/template/new'
      preLoaderRoute: typeof AppTemplateNewRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/template/$templateId': {
      id: '/app/template/$templateId'
      path: '/template/$templateId'
      fullPath: '/app/template/$templateId'
      preLoaderRoute: typeof AppTemplateTemplateIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/clients/$clientId': {
      id: '/app/clients/$clientId'
      path: '/clients/$clientId'
      fullPath: '/app/clients/$clientId'
      preLoaderRoute: typeof AppClientsClientIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/clients/$clientId/': {
      id: '/app/clients/$clientId/'
      path: '/'
      fullPath: '/app/clients/$clientId/'
      preLoaderRoute: typeof AppClientsClientIdIndexRouteImport
      parentRoute: typeof AppClientsClientIdRoute
    }
    '/app/clients/$clientId/session/$eventId': {
      id: '/app/clients/$clientId/session/$eventId'
      path: '/session/$eventId'
      fullPath: '/app/clients/$clientId/session/$eventId'
      preLoaderRoute: typeof AppClientsClientIdSessionEventIdRouteImport
      parentRoute: typeof AppClientsClientIdRoute
    }
    '/app/clients/$clientId/document/$documentId': {
      id: '/app/clients/$clientId/document/$documentId'
      path: '/document/$documentId'
      fullPath: '/app/clients/$clientId/document/$documentId'
      preLoaderRoute: typeof AppClientsClientIdDocumentDocumentIdRouteImport
      parentRoute: typeof AppClientsClientIdRoute
    }
  }
}

interface AppClientsClientIdRouteChildren {
  AppClientsClientIdIndexRoute: typeof AppClientsClientIdIndexRoute
  AppClientsClientIdDocumentDocumentIdRoute: typeof AppClientsClientIdDocumentDocumentIdRoute
  AppClientsClientIdSessionEventIdRoute: typeof AppClientsClientIdSessionEventIdRoute
}

const AppClientsClientIdRouteChildren: AppClientsClientIdRouteChildren = {
  AppClientsClientIdIndexRoute: AppClientsClientIdIndexRoute,
  AppClientsClientIdDocumentDocumentIdRoute:
    AppClientsClientIdDocumentDocumentIdRoute,
  AppClientsClientIdSessionEventIdRoute: AppClientsClientIdSessionEventIdRoute,
}

const AppClientsClientIdRouteWithChildren =
  AppClientsClientIdRoute._addFileChildren(AppClientsClientIdRouteChildren)

interface AppRouteChildren {
  AppFaqRoute: typeof AppFaqRoute
  AppSettingsRoute: typeof AppSettingsRoute
  AppTemplatesRoute: typeof AppTemplatesRoute
  AppIndexRoute: typeof AppIndexRoute
  AppClientsClientIdRoute: typeof AppClientsClientIdRouteWithChildren
  AppTemplateTemplateIdRoute: typeof AppTemplateTemplateIdRoute
  AppTemplateNewRoute: typeof AppTemplateNewRoute
  AppClientsIndexRoute: typeof AppClientsIndexRoute
}

const AppRouteChildren: AppRouteChildren = {
  AppFaqRoute: AppFaqRoute,
  AppSettingsRoute: AppSettingsRoute,
  AppTemplatesRoute: AppTemplatesRoute,
  AppIndexRoute: AppIndexRoute,
  AppClientsClientIdRoute: AppClientsClientIdRouteWithChildren,
  AppTemplateTemplateIdRoute: AppTemplateTemplateIdRoute,
  AppTemplateNewRoute: AppTemplateNewRoute,
  AppClientsIndexRoute: AppClientsIndexRoute,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

interface CheckoutRouteChildren {
  CheckoutSuccessRoute: typeof CheckoutSuccessRoute
  CheckoutIndexRoute: typeof CheckoutIndexRoute
}

const CheckoutRouteChildren: CheckoutRouteChildren = {
  CheckoutSuccessRoute: CheckoutSuccessRoute,
  CheckoutIndexRoute: CheckoutIndexRoute,
}

const CheckoutRouteWithChildren = CheckoutRoute._addFileChildren(
  CheckoutRouteChildren,
)

interface OrganisationRouteChildren {
  OrganisationBillingRoute: typeof OrganisationBillingRoute
  OrganisationClientTransfersRoute: typeof OrganisationClientTransfersRoute
  OrganisationGeneralRoute: typeof OrganisationGeneralRoute
  OrganisationMembersRoute: typeof OrganisationMembersRoute
  OrganisationNewRoute: typeof OrganisationNewRoute
  OrganisationPermissionsRoute: typeof OrganisationPermissionsRoute
  OrganisationIndexRoute: typeof OrganisationIndexRoute
}

const OrganisationRouteChildren: OrganisationRouteChildren = {
  OrganisationBillingRoute: OrganisationBillingRoute,
  OrganisationClientTransfersRoute: OrganisationClientTransfersRoute,
  OrganisationGeneralRoute: OrganisationGeneralRoute,
  OrganisationMembersRoute: OrganisationMembersRoute,
  OrganisationNewRoute: OrganisationNewRoute,
  OrganisationPermissionsRoute: OrganisationPermissionsRoute,
  OrganisationIndexRoute: OrganisationIndexRoute,
}

const OrganisationRouteWithChildren = OrganisationRoute._addFileChildren(
  OrganisationRouteChildren,
)

interface SettingsSupportRouteChildren {
  SettingsSupportThreadIdRoute: typeof SettingsSupportThreadIdRoute
  SettingsSupportNewRoute: typeof SettingsSupportNewRoute
  SettingsSupportIndexRoute: typeof SettingsSupportIndexRoute
}

const SettingsSupportRouteChildren: SettingsSupportRouteChildren = {
  SettingsSupportThreadIdRoute: SettingsSupportThreadIdRoute,
  SettingsSupportNewRoute: SettingsSupportNewRoute,
  SettingsSupportIndexRoute: SettingsSupportIndexRoute,
}

const SettingsSupportRouteWithChildren = SettingsSupportRoute._addFileChildren(
  SettingsSupportRouteChildren,
)

interface SettingsRouteChildren {
  SettingsInvitationsRoute: typeof SettingsInvitationsRoute
  SettingsPreferencesRoute: typeof SettingsPreferencesRoute
  SettingsProfileRoute: typeof SettingsProfileRoute
  SettingsSecurityRoute: typeof SettingsSecurityRoute
  SettingsSupportRoute: typeof SettingsSupportRouteWithChildren
  SettingsIndexRoute: typeof SettingsIndexRoute
}

const SettingsRouteChildren: SettingsRouteChildren = {
  SettingsInvitationsRoute: SettingsInvitationsRoute,
  SettingsPreferencesRoute: SettingsPreferencesRoute,
  SettingsProfileRoute: SettingsProfileRoute,
  SettingsSecurityRoute: SettingsSecurityRoute,
  SettingsSupportRoute: SettingsSupportRouteWithChildren,
  SettingsIndexRoute: SettingsIndexRoute,
}

const SettingsRouteWithChildren = SettingsRoute._addFileChildren(
  SettingsRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AppRoute: AppRouteWithChildren,
  AuthRoute: AuthRoute,
  CheckoutRoute: CheckoutRouteWithChildren,
  ForgotPasswordRoute: ForgotPasswordRoute,
  LegalRoute: LegalRoute,
  OrganisationRoute: OrganisationRouteWithChildren,
  RegisterRoute: RegisterRoute,
  ResetPasswordRoute: ResetPasswordRoute,
  SettingsRoute: SettingsRouteWithChildren,
  SigninRoute: SigninRoute,
  SubscribeRoute: SubscribeRoute,
  ConsentTokenRoute: ConsentTokenRoute,
  ConsentInfoRoute: ConsentInfoRoute,
  MobileRecordTokenRoute: MobileRecordTokenRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
